// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.pagination button {
  border: none;
  background: transparent;
}
.pagination span {
  display: flex;
  gap: 10px;
  padding: 0 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/pagination/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AACF;AACE;EACE,YAAA;EACA,uBAAA;AACJ;AAEE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAAJ","sourcesContent":[".pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n\n  button {\n    border: none;\n    background: transparent;\n  }\n\n  span {\n    display: flex;\n    gap: 10px;\n    padding: 0 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
